export default {
  tarifs: [
    {
      id: '590',
      label: {
        de: 'Komplementärmedizin VVG',
        fr: 'Médecine complémentaire LCA',
        it: 'Medicina complementare LCA'
      }
    },
    {
      id: '999',
      label: {
        de: 'Leistungen, die in keinem der aufgeführten Tarife enthalten sind',
        fr: 'Prestations ne figurant dans aucun des tarifs énumérés',
        it: 'Servizi non inclusi in nessuna delle tariffe elencate'
      }
    }
  ],
  categories: [
    {
      id: '1',
      label18: {
        de: 'Allgemeine Tarifziffern',
        fr: 'Numéros tarifaires généraux',
        it: 'Cifre tariffarie generali'
      }
    },
    {
      id: '2',
      label18: { de: 'Leistungen', fr: 'Prestations', it: 'Prestazioni' }
    },
    { id: '3', label18: { de: 'Heilmittel', fr: 'Remède', it: 'Rimedio' } },
    { id: '4', label18: { de: 'Labor', fr: 'Laboratoire', it: 'Laboratorio' } },
    {
      id: '5',
      label18: {
        de:
          'Naturheilpraktiker (NHP) mit Zertifikat OdA AM oder eidgenössischem Diplom',
        fr: 'Naturopathe avec le Certificat OrTra MA ou diplôme fédéral',
        it: 'Naturopata con Certificato OmL MA o Diploma federale'
      }
    },
    {
      id: '5.0',
      label18: {
        de: 'Naturheilpraktiker (NHP) mit eidgenössischem Diplom',
        fr: 'Naturopathe avec diplôme fédéral',
        it: 'Naturopata con Diploma federale'
      }
    },
    {
      id: '5.1',
      label18: {
        de: 'NHP Fachrichtung Ayurveda',
        fr: 'Naturopathe discipline Médecine ayurvédique',
        it: 'Naturopata disciplina Medicina ayurvedica'
      }
    },
    {
      id: '5.2',
      label18: {
        de: 'NHP Fachrichtung Homöopathie',
        fr: 'Naturopathe discipline Homéopathie',
        it: 'Naturopata disciplina Omeopatia'
      }
    },
    {
      id: '5.3',
      label18: {
        de: 'NHP Fachrichtung TCM',
        fr: 'Naturopathe discipline Médecine traditionnelle chinoise MTC',
        it: 'Naturopata disciplina Medicina tradizionale cinese MTC'
      }
    },
    {
      id: '5.4',
      label18: {
        de: 'NHP Fachrichtung TEN',
        fr:
          'Naturopathe discipline Médecine naturelle traditionnelle européenne MTE',
        it: 'Naturopata disciplina Medicina naturale tradizionale europea MTE'
      }
    },
    {
      id: '6',
      label18: {
        de:
          'Komplementärtherapeut (KT) mit Branchenzertifikat OdA KT oder eigenössischem Diplom',
        fr:
          'Thérapeute Complémentaire TC avec Certificat de Branche OrTra TC ou diplôme fédéral',
        it:
          'Terapista Complementare (TC) con Certificato Settoriale OmL TC o diploma federale'
      }
    },
    {
      id: '6.0',
      label18: {
        de:
          'Komplementärtherapeut (KT) mit Branchenzertifikat oder eigenössischem Diplom',
        fr:
          'Thérapeute Complémentaire TC avec Certificat de Branche OrTra TC ou diplôme fédéral',
        it:
          'Terapista Complementare (TC) con Certificato Settoriale OmL TC o diploma federale'
      }
    },
    {
      id: '6.1',
      label18: {
        de: 'KT Methode Akupressur',
        fr: 'Thérapeute Complémentaire méthode Acupressure thérapie',
        it: 'Terapista Complementare metodi Agopressione terapia'
      }
    },
    {
      id: '6.2',
      label18: {
        de: 'KT Methode AlexanderTechnik',
        fr: 'Méthode TC Technique Alexander',
        it: 'Metodo TC Tecnica Alexander'
      }
    },
    {
      id: '6.3',
      label18: {
        de: 'KT Methode APM- Therapie (Akupunktmassage- Therapie)',
        fr:
          "Méthode TC APM thérapie (Thérapie par le massage sur méridien d'acupuncture)",
        it:
          "Metodo TC APM Terapia (Terapia per il massaggio su meridiani d'agopuntura)"
      }
    },
    {
      id: '6.4',
      label18: {
        de: 'KT Methode Atemtherapie',
        fr: 'Méthode TC Thérapie respiratoire',
        it: 'Metodo TC Terapia del respiro'
      }
    },
    {
      id: '6.5',
      label18: {
        de: 'KT Methode Ayurveda Therapie',
        fr: 'Méthode TC Ayurvéda thérapie',
        it: 'Metodo TC Ayurveda terapia'
      }
    },
    {
      id: '6.6',
      label18: {
        de: 'KT Methode Bewegungs- und Körpertherapie',
        fr: 'Méthode TC Thérapie corporelle par le mouvement',
        it: 'Metodo TC Terapia per il corpo e del movimento'
      }
    },
    {
      id: '6.7',
      label18: {
        de: 'KT Methode Craniosacral Therapie',
        fr: 'Méthode TC Thérapie craniosacrale',
        it: 'Metodo TC Terapia craniosacrale'
      }
    },
    {
      id: '6.8',
      label18: {
        de: 'KT Methode Eutonie',
        fr: 'Méthode TC Eutonie',
        it: 'Metodo TC Eutonia'
      }
    },
    {
      id: '6.9',
      label18: {
        de: 'KT Methode Feldenkrais Therapie',
        fr: 'Méthode TC Thérapie Feldenkrais',
        it: 'Metodo TC Terapia Feldenkrais'
      }
    },
    {
      id: '6.10',
      label18: {
        de: 'KT Methode Heileurythmie',
        fr: 'Méthode TC Eurythmie thérapeutique',
        it: 'Metodo TC Euritmia Terapeutica'
      }
    },
    {
      id: '6.11',
      label18: {
        de: 'KT Methode Kinesiologie',
        fr: 'Méthode TC Kinésiologie',
        it: 'Metodo TC Kinesiologia'
      }
    },
    {
      id: '6.12',
      label18: {
        de: 'KT Methode Polarity',
        fr: 'Méthode TC Polarity',
        it: 'Metodo TC Polarity'
      }
    },
    {
      id: '6.13',
      label18: {
        de: 'KT Methode Rebalancing',
        fr: 'Méthode TC Rebalancing',
        it: 'Metodo TC Rebalancing'
      }
    },
    {
      id: '6.14',
      label18: {
        de: 'KT Methode Reflexzonentherapie',
        fr: 'Méthode TC Réflexothérapie',
        it: 'Metodo TC Riflessoterapia'
      }
    },
    {
      id: '6.15',
      label18: {
        de: 'KT Methode Shiatsu',
        fr: 'Méthode TC Shiatsu',
        it: 'Metodo TC Shiatsu'
      }
    },
    {
      id: '6.16',
      label18: {
        de: 'KT Methode Strukturelle',
        fr: 'Méthode TC Intégration structurale',
        it: 'Metodo TC Integrazione strutturale'
      }
    },
    {
      id: '6.17',
      label18: {
        de: 'KT Methode Yoga',
        fr: 'Méthode TC Yoga',
        it: 'Metodo TC Yoga'
      }
    },
    {
      id: '6.18',
      label18: {
        de: 'KT Methode Biodynamik',
        fr: 'Méthode TC Thérapie',
        it: 'Metodo TC Fasciaterapia'
      }
    },
    {
      id: '6.19',
      label18: {
        de: 'KT Methode Faszientherapie',
        fr: 'Méthode TC Fasciathérapie',
        it: 'Metodo TC Fasciaterapia'
      }
    },
    {
      id: '7',
      label18: {
        de: 'Kunsttherapeut (KST) mit eidgenössischem Diplom',
        fr: 'Art-thérapeute avec diplôme fédéral',
        it: 'Arteterapia con Diploma federale'
      }
    },
    {
      id: '7.0',
      label18: {
        de: 'Kunsttherapeut (KST) mit eidgenössischem Diplom',
        fr: 'Art-thérapeute avec diplôme fédéral',
        it: 'Arteterapia con Diploma federale'
      }
    },
    {
      id: '7.1',
      label18: {
        de: 'KST Fachrichtung Bewegungs- und Tanztherapie',
        fr:
          'Art-thérapeute Spécialisation Thérapie par le mouvement et la danse',
        it:
          'Arteterapia Specializzazione di terapisti della danze e di movimenti'
      }
    },
    {
      id: '7.2',
      label18: {
        de: 'KST Fachrichtung Drama- und Sprachtherapie',
        fr: 'Art-thérapeute Spécialisation Thérapie par le drama et la parole',
        it: 'Arteterapia Specializzazione di terapisti della parola e dramma'
      }
    },
    {
      id: '7.3',
      label18: {
        de: 'KST Fachrichtung Gestaltungs- und Maltherapie',
        fr:
          'Art-thérapeute Spécialisation Thérapie à médiation plastique et visuelle',
        it:
          'Arteterapia Specializzazione di terapisti di modellagio e della pittura'
      }
    },
    {
      id: '7.4',
      label18: {
        de: 'KST Fachrichtung Intermediale Therapie',
        fr: 'Art-thérapeute Spécialisation Thérapie intermédiale',
        it: 'Arteterapia Specializzazione di terapisti intermediale'
      }
    },
    {
      id: '7.5',
      label18: {
        de: 'KST Fachrichtung Musiktherapie',
        fr: 'Art-thérapeute Spécialisation Musicothérapie',
        it: 'Arteterapia Specializzazione di terapisti Musicoterapia'
      }
    },
    {
      id: '8',
      label18: {
        de: 'Medizinischer Masseur mit eidgenössichem Fachausweis',
        fr: 'Masseurs médicaux avec certificat fédéral',
        it: 'Massagiatori medicali con certificato federale'
      }
    },
    {
      id: '9',
      label18: {
        de: 'Osteopath FH (BSc/MSc) oder GDK Diplom',
        fr: 'Ostéopathe avec BSc/MSc HES en Ostéopathie / diplôme CDS',
        it: 'Osteopatia con BSc/MSc HES Osteopatia diplomata CDS'
      }
    }
  ],
  positions: [
    {
      id: '1200',
      tarif: '590',
      category: '1',
      label: {
        de: 'Anamnese / Untersuchung / Diagnostik / Befunderhebung, pro 5 Min.',
        fr:
          'Anamnèse / bilan / diagnostique / constatations médicales, par période de 5 minutes',
        it: 'anamnesi / esame / diagnostica / reperto, ogni 5 min. '
      },
      description: {
        de:
          'Anamnese (Personalien, Vorgeschichte, bisherige Therapien oder Behandlungen, Medikamente, Risiken, etc.), Untersuchungen sowie methoden- und fachrichtungsunabhängige Diagnostik und Befunderhebung.',
        fr:
          'Anamnèse (données personnelles, antécédents médicaux, thérapies ou traitements antérieurs, médicaments, risques, etc.), examens ainsi que diagnostics et résultats indépendants de la Méthode et de la spécialité.',
        it:
          'Anamnesi (dati personali, anamnesi, storia medica, terapie o trattamenti precedenti, farmaci, rischi, ecc.), esami, nonché diagnosi e risultati di metodi e specialità indipendenti.'
      },
      validFrom: '2016-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1250',
      tarif: '590',
      category: '1',
      label: {
        de: 'Verpasste Konsultation',
        fr: 'Consultation manquée',
        it: 'consultazione mancata'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2018-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1251',
      tarif: '590',
      category: '1',
      label: {
        de: 'Zuschlag Nacht, Sonn- und Feiertage',
        fr: 'Supplément nuit, dimanche et jours fériés',
        it: 'Supplemento notte, domenica e giorni festivi'
      },
      description: {
        de:
          'Pauschaler Zuschlag für Behandlungen in der Nacht (zw. 22-06 Uhr), sowie an Sonn- und Feiertagen',
        fr:
          'Supplément forfaitaire pour traitements de nuit (entre 22h00-06h00), ainsi que les dimanches et jours fériés',
        it:
          'Supplemento forfettario per trattamenti effettuati durante la notte (dalle ore 22 alle ore 6), la domenica o nei giorni festivi.'
      },
      validFrom: '2018-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1252',
      tarif: '590',
      category: '1',
      label: {
        de: 'Zuschlag ausserordentliche Konsultation in Akutsituationen',
        fr: 'Supplément consultation extraordinaire dans des situations aigües',
        it:
          'Supplemento per consultazione straordinaria in situazioni d’emergenza'
      },
      description: {
        de:
          'Pauschaler Zuschlag für ungeplante Akutbehandlungen. Darf nicht mit der Tarifziffer 1251 kombiniert werden.',
        fr:
          'Supplément forfaitaire pour traitements aigus imprévus. Ne doit pas être combiné avec le chiffre tarifaire 1251.',
        it:
          'Supplemento forfettario per trattamenti d’urgenza non pianificati. Non deve essere combinato con la cifra tariffaria 1251.'
      },
      validFrom: '2018-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1253',
      tarif: '590',
      category: '1',
      label: {
        de: 'Formalisierter Bericht',
        fr: 'Rapport formalisé',
        it: 'Rapporto formalizzato'
      },
      description: {
        de:
          'Pauschale für die Beantwortung eines Fragebogens. Enthält in der Regel die Antworten auf gezielte Fragen des Versicherers.',
        fr:
          "Forfaits pour la réponse à un questionnaire. Comprend en règle générale les réponses à des questions ciblées de l'assureur.",
        it:
          'Forfait per la compilazione di un questionario. Contiene generalmente le risposte a domande mirate dell’assicuratore.'
      },
      validFrom: '2018-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1254',
      tarif: '590',
      category: '1',
      label: {
        de: 'Nicht formalisierter Bericht',
        fr: 'Rapport non formalisé',
        it: 'Rapporto non formalizzato'
      },
      description: {
        de:
          'Pauschale für die Erstellung eines Berichts. Nicht formalisierte Berichte sind in der Gestaltung frei. ',
        fr:
          "Forfaits pour établissement d'un rapport. La conception des rapports non formalisés est libre.",
        it:
          'Forfait per la redazione di un rapporto. I rapporti non formalizzati possono essere redatti liberamente senza dover rispettare una struttura prefissata.'
      },
      validFrom: '2018-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1255',
      tarif: '590',
      category: '1',
      label: {
        de: 'Blutegel, pro Stück',
        fr: 'Leeches, par pièce',
        it: 'Sanguisuga, per pezzo'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2019-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1256',
      tarif: '590',
      category: '1',
      label: {
        de: 'Wegentschädigung',
        fr: 'Compensation de voyage',
        it: 'compensazione di viaggio'
      },
      description: {
        de: 'Pauschaler Zuschlag für die Wegentschädigung für Hausbesuche',
        fr:
          "Supplément forfaitaire pour l'indemnité de déplacement pour les visites à domicile",
        it:
          "Supplemento forfettario per l'indennità di viaggio per le visite a domicilio"
      },
      validFrom: '2019-01-01',
      validTo: '9998-12-31'
    },

    {
      id: '1001',
      tarif: '590',
      category: '2',
      label: {
        de: 'Aderlass, pro 5 Minuten',
        fr: 'Saignée, par période de 5 minutes',
        it: 'Salasso, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '2016-12-31'
    },
    {
      id: '1002',
      tarif: '590',
      category: '2',
      label: {
        de: 'Akumattherapie, pro 5 Minuten',
        fr: 'Thérapie Akumat, par période de 5 minutes',
        it: 'Terapia Akumat, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '2019-12-31'
    },
    {
      id: '1003',
      tarif: '590',
      category: '2',
      label: {
        de: 'Akupressur, pro 5 Minuten',
        fr: 'Acupressure, par période de 5 minutes',
        it: 'Agopressione, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1004',
      tarif: '590',
      category: '2',
      label: {
        de: 'Akupunktur, pro 5 Minuten',
        fr: 'Acupuncture, par période de 5 minutes',
        it: 'Agopuntura, ogni 5 min.'
      },
      description: {
        de:
          'Beinhaltet Elektroakupunktur, Laser-Akupunktur, Moxibustion, Ohrakupunktur, Schädelakupunktur, Augenakupunktur',
        fr:
          "Comprend l'électroacupuncture, l'acupuncture au laser, la moxibustion, l'auriculothérapie, acupuncture du crâne, acupuncture oculaire",
        it:
          'Comprende elettroagopuntura, agopuntura al laser, moxibustione, agopuntura auricolare, agopuntura del cranio, agopuntura per gli occhi'
      },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1005',
      tarif: '590',
      category: '2',
      label: {
        de: 'Akupunktmassage-Therapie (APM-Therapie), pro 5 Minuten',
        fr:
          "Thérapie par le massage sur méridiens d'acupuncture, par période de 5 minutes",
        it: 'Terapia per il massaggio su meridiani d’agopuntura, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1006',
      tarif: '590',
      category: '2',
      label: {
        de: 'Alexander-Technik, pro 5 Minuten',
        fr: 'Technique Alexander, par période de 5 minutes',
        it: 'Tecnica Alexander, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1007',
      tarif: '590',
      category: '2',
      label: {
        de: 'Tui-Na/An-Mo, pro 5 Minuten',
        fr: 'Tui-Na/An-Mo, par période de 5 minutes',
        it: 'Tui-Na/An-Mo, ogni 5 min.'
      },
      description: {
        de: 'Beinhaltet Moxibustion',
        fr: 'Comprend moxibustion',
        it: 'Comprende moxibustione'
      },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1008',
      tarif: '590',
      category: '2',
      label: {
        de: 'Anthroposophische Medizin, Behandlung/Konsultation, pro 5 Minuten',
        fr:
          'Médécine anthroposophique, traitement/consultation, par période de 5 minutes',
        it: 'Medicina antroposofica, trattamento/consultazione, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1010',
      tarif: '590',
      category: '2',
      label: {
        de: 'Aromatherapie, pro 5 Minuten',
        fr: 'Aromathérapie, par période de 5 minutes',
        it: 'Aromaterapia, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1011',
      tarif: '590',
      category: '2',
      label: {
        de: 'Asiatische Körper- und Energiearbeit, pro 5 Minuten',
        fr: 'Travail asiatique d’énergie et du corps, par période de 5 minutes',
        it: "Terapia asiatica per il corpo e l'energia, ogni 5 min."
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1012',
      tarif: '590',
      category: '2',
      label: {
        de: 'Atemtherapie, pro 5 Minuten',
        fr: 'Thérapie respiratoire, par période de 5 minutes',
        it: 'Terapia respiratoria, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1013',
      tarif: '590',
      category: '2',
      label: {
        de: 'Atlaslogie, pro 5 Minuten',
        fr: 'Atlaslogie, par période de 5 minutes',
        it: 'Atlaslogia, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1014',
      tarif: '590',
      category: '2',
      label: {
        de: 'Audio-Psycho-Phonologie/Tomatis, pro 5 Minuten',
        fr: 'Audio-psycho-phonologie/Tomatis, par période de 5 minutes',
        it: 'Audiopsicofonologia/Tomatis, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1016',
      tarif: '590',
      category: '2',
      label: {
        de: 'Aura-Soma-Therapie, pro 5 Minuten',
        fr: 'Auro-Soma thérapie, par période de 5 minutes',
        it: 'Aura Soma terapia, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1017',
      tarif: '590',
      category: '2',
      label: {
        de: 'Autogenes Training, pro 5 Minuten',
        fr: 'Training autogène, par période de 5 minutes',
        it: 'Training autogeno, ogni 5 min.'
      },
      description: {
        de:
          'Gesprächstherapie bzw. Psychotherapie ist kein Bestandteil des Autogenen Trainings',
        fr:
          'La thérapie par la parole ou la psychothérapie ne fait pas partie du training autogène.',
        it:
          'I colloqui psicoterapeutici o la psicoterapia non sono parte del training autogeno'
      },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1021',
      tarif: '590',
      category: '2',
      label: {
        de: 'Ayurveda-Massage, pro 5 Minuten',
        fr: 'Massage ayurvédique, par période de 5 minutes',
        it: 'Massaggio ayurvedico, ogni 5 min.'
      },
      description: {
        de:
          'Beinhaltet Ganz- und Teilkörper Ölbehandlungen (Kopf, Rücken, Füsse, Vitalpunkte), Ganzkörper-Behandlungen mit Pulver und Pasten',
        fr:
          "Comprend traitements à l'huile d'une partie ou de tout le corps (tête, dos, pieds, points vitaux), traitements corporels avec des poudres et pâtes.",
        it:
          'Comprende trattamenti completi e parziali del corpo con oli (testa, schiena, piedi, punti vitali), trattamenti completi con paste e polveri'
      },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1022',
      tarif: '590',
      category: '2',
      label: {
        de: 'Bachblüten-Therapie, pro 5 Minuten',
        fr: 'Thérapie des fleurs de Bach, par période de 5 minutes',
        it: 'Terapia dei fiori di Bach, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1023',
      tarif: '590',
      category: '2',
      label: {
        de: 'Baunscheidttherapie, pro 5 Minuten',
        fr: 'Méthode Baunscheidt, par période de 5 minutes',
        it: 'Metodo Baunscheidt, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '2016-12-31'
    },
    {
      id: '1024',
      tarif: '590',
      category: '2',
      label: {
        de: 'Bewegungstherapie, pro 5 Minuten',
        fr:
          'Thérapie par le mouvement (intégrat./cliniq.), par période de 5 minutes',
        it: 'Terapia dei movimenti, integrativa/clinica, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1025',
      tarif: '590',
      category: '2',
      label: {
        de: 'Bindegewebsmassage, pro 5 Minuten',
        fr: 'Massage du tissu conjonctif, par période de 5 minutes',
        it: 'Massaggio del tessuto connettivo, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1026',
      tarif: '590',
      category: '2',
      label: {
        de: 'Bio-Feedback (exkl. Neurofeedback), pro 5 Minuten',
        fr: 'Biofeedback, par période de 5 minutes',
        it: 'Biofeedback, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1027',
      tarif: '590',
      category: '2',
      label: {
        de: 'Bioresonanz-Therapie, pro 5 Minuten',
        fr: 'Biorésonance, par période de 5 minutes',
        it: 'Biorisonanza, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1028',
      tarif: '590',
      category: '2',
      label: {
        de: 'Biochemie nach Schüssler, Behandlung/Konsultation, pro 5 Minuten',
        fr: 'Biochimie selon Schüssler, par période de 5 minutes',
        it: 'Biochimica secondo Schüssler, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1029',
      tarif: '590',
      category: '2',
      label: {
        de: 'Biodynamische Psychologie/Biodynamik, pro 5 Minuten',
        fr: 'Psychologie biodynamique/Biodynamique, par période de 5 minutes',
        it: 'Psicologia biodinamica / biodinamica, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1030',
      tarif: '590',
      category: '2',
      label: {
        de: 'Blutegel-Therapie, pro 5 Minuten ',
        fr: 'Sangsues, par période de 5 minutes',
        it: 'Sanguisughe, ogni 5 min. '
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1031',
      tarif: '590',
      category: '2',
      label: {
        de: 'Brain Gym, pro 5 Minuten',
        fr: 'Brain Gym, par période de 5 minutes',
        it: 'Brain Gym, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1032',
      tarif: '590',
      category: '2',
      label: {
        de: 'Colon-Hydro-Therapie, pro 5 Minuten',
        fr: 'Hydrothérapie du côlon, par période de 5 minutes',
        it: 'Idroterapia del colon, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1033',
      tarif: '590',
      category: '2',
      label: {
        de: 'Colon-Massage, pro 5 Minuten',
        fr: 'Massage du côlon, par période de 5 minutes',
        it: 'Massaggio del colon, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1034',
      tarif: '590',
      category: '2',
      label: {
        de: 'Craniosacral Therapie, pro 5 Minuten',
        fr: 'Thérapie craniosacrale, par période de 5 minutes',
        it: 'Terapia craniosacrale, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1035',
      tarif: '590',
      category: '2',
      label: {
        de: 'Deep Draining, pro 5 Minuten',
        fr: 'Deep Draining, par période de 5 minutes',
        it: 'Deep Draining, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1036',
      tarif: '590',
      category: '2',
      label: {
        de: 'Eigenblut-/Autosanguistufentherapie, pro 5 Minuten',
        fr: 'Autohémothérapie/thérapie autosanguine ',
        it: 'Autoemoterapia / Terapia autosanguinea'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1037',
      tarif: '590',
      category: '2',
      label: {
        de: 'Elektroakupunktur, pro 5 Minuten    ',
        fr: 'Électroacupuncture, par période de 5 minutes',
        it: 'Elettroagopuntura, ogni 5 min.    '
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1038',
      tarif: '590',
      category: '2',
      label: {
        de: 'Elektroakupunktur nach Voll, pro 5 Minuten    ',
        fr: 'Électroacupuncture selon Voll, par période de 5 minutes',
        it: 'Elettroagopuntura secondo Voll, ogni 5 min.    '
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1039',
      tarif: '590',
      category: '2',
      label: {
        de: 'Elektrotherapie, pro 5 Minuten',
        fr: 'Électrothérapie, par période de 5 minutes',
        it: 'Elettroterapia, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1041',
      tarif: '590',
      category: '2',
      label: {
        de: 'Ernährungsberatung/Diätetik, pro 5 Minuten',
        fr: 'Conseil diététique, par période de 5 minutes',
        it: 'Consigli dietetici / dietetica, ogni 5 min.'
      },
      description: {
        de: '(beendet, siehe 1206 und 1207)',
        fr: '(Terminé, voir 1206 et 1207)',
        it: '(Terminato, vedi 1206 e 1207)'
      },
      validFrom: '2009-01-01',
      validTo: '2016-12-31'
    },
    {
      id: '1045',
      tarif: '590',
      category: '2',
      label: {
        de: 'Esalen Massage, pro 5 Minuten',
        fr: 'Massage ésalien, par période de 5 minutes',
        it: 'Massaggio Esalen, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1047',
      tarif: '590',
      category: '2',
      label: {
        de: 'Eutonie Gerda Alexander, pro 5 Minuten',
        fr: 'Eutonie Gerda Alexander, par période de 5 minutes',
        it: 'Eutonia Gerda Alexander, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1048',
      tarif: '590',
      category: '2',
      label: {
        de: 'Farbpunktur, pro 5 Minuten',
        fr: 'Chromopuncture, par période de 5 minutes',
        it: 'Cromopuntura, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1049',
      tarif: '590',
      category: '2',
      label: {
        de: 'Farbtherapie, pro 5 Minuten',
        fr: 'Thérapie par la couleur, par période de 5 minutes',
        it: 'Cromoterapia, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1050',
      tarif: '590',
      category: '2',
      label: {
        de: 'Fasciatherapie, pro 5 Minuten',
        fr: 'Fasciathérapie, par période de 5 minutes',
        it: 'Fasciaterapia, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1051',
      tarif: '590',
      category: '2',
      label: {
        de: 'Feldenkrais-Therapie, pro 5 Minuten',
        fr: 'Méthode Feldenkrais, par période de 5 minutes',
        it: 'Metodo Feldenkrais, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1052',
      tarif: '590',
      category: '2',
      label: {
        de: 'Fussreflexzonen-Therapie pro 5 Minuten',
        fr: 'Massage des zones réflexes du pied, par période de 5 minutes',
        it: 'Riflessologia plantare, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1053',
      tarif: '590',
      category: '2',
      label: {
        de: 'Hämatogene Oxydationstherapie, pro 5 Minuten',
        fr: 'Thérapie d’oxydation hématogène, par période de 5 minutes',
        it: "Terapia d'ossidazione ematogena, ogni 5 min."
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1054',
      tarif: '590',
      category: '2',
      label: {
        de: 'Yoga-Therapie, pro 5 Minuten',
        fr: 'Yoga thérapie, par période de 5 minutes',
        it: 'Yoga terapia, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1055',
      tarif: '590',
      category: '2',
      label: {
        de: 'Heileurythmie, pro 5 Minuten',
        fr: 'Eurythmie thérapeutique, par période de 5 minutes',
        it: 'Euritmia terapeutica, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1056',
      tarif: '590',
      category: '2',
      label: {
        de: 'Heilpädagogisches Reiten, Therapeutisches Reiten, pro 5 Minuten',
        fr: 'Hippothérapie, par période de 5 minutes',
        it: 'Equitazione pedagogica, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1057',
      tarif: '590',
      category: '2',
      label: {
        de: 'Homöopathie, Behandlung/Konsultation, pro 5 Minuten',
        fr: 'Homéopathie, par période de 5 minutes',
        it: 'Omeopatia, ogni 5 min.'
      },
      description: {
        de:
          'Diese Tarifziffer beinhaltet alle fachrichtungsspezifischen Verrichtungen im direkten Kontakt mit dem Patienten (homöopathische Anamnese, inkl. telefonische Konsultation), ausgenommen die Repertorisation (siehe Tarifziffer 1127)',
        fr:
          "Ce code tarifaire comprend toutes les activités spécifiques à une spécialité en contact direct avec le patient (anamnèse homéopathique, y compris la consultation téléphonique), à l'exception de la répertorisation (voir code tarifaire 1127).",
        it:
          'Questa codice tariffa comprende tutte le attività specialistiche specifiche a diretto contatto con il paziente (anamnesi omeopatica, compresa la consulenza telefonica), ad eccezione della repertorizzazione (vedi codice tariffa 1127).'
      },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1058',
      tarif: '590',
      category: '2',
      label: {
        de: 'Hydrotherapie,  pro 5 Minuten',
        fr: 'Hydrothérapie, par période de 5 minutes',
        it: 'Idroterapia, ogni 5 min.'
      },
      description: {
        de:
          'Beinhaltet Güsse, Waschungen, Bäder, Kneipp- Wasseranwendungen, Balneologie, Wickel, Umschläge, Fango',
        fr:
          "Comprend jets, lavages, bains, utilisations de l'eau selon Kneipp, balnéologie, cataplasmes, enveloppements, fango",
        it:
          "Comprende getti, lavaggi, bagni, trattamenti Kneipp utilizzo dell'acqua, balneoterapia, cataplasmi, impacchi, fango"
      },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1060',
      tarif: '590',
      category: '2',
      label: {
        de: 'Kinesiologie, pro 5 Minuten',
        fr: 'Kinésiologie, par période de 5 minutes',
        it: 'Kinesiologia, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1061',
      tarif: '590',
      category: '2',
      label: {
        de: 'Klangtherapie pro  5 Minuten',
        fr: 'Thérapie sonore, par période de 5 minutes',
        it: 'Terapia del suono, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1062',
      tarif: '590',
      category: '2',
      label: {
        de: 'Klassische Massage, pro 5 Minuten',
        fr: 'Massage classique, par période de 5 minutes',
        it: 'Massaggio classico, ogni 5 min.'
      },
      description: {
        de:
          'Synonyme zur klassischen Massage: empirische, therapeutische Massage inkl. Colon-Massage',
        fr:
          'Synonymes pour massage classique: massage empirique, thérapeutique, y c. massage du côlon.',
        it:
          'Sinonimi di massaggio classico: massaggio empirico, terapeutico incl. massaggio del colon'
      },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1063',
      tarif: '590',
      category: '2',
      label: {
        de: 'Kneipp-Therapie, pro 5 Minuten',
        fr: 'Thérapie selon Kneipp, par période de 5 minutes',
        it: 'Terapia Kneipp, ogni 5 min.'
      },
      description: {
        de: 'Gesamtkonzept (5 Säulen)',
        fr: 'Concept total (5 piliers)',
        it: 'Concetto totale (5 colonne)'
      },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1064',
      tarif: '590',
      category: '2',
      label: {
        de: 'Laser-Akupunktur, pro 5 Minuten',
        fr: 'Acupuncture par laser, par période de 5 minutes',
        it: 'Agopuntura laser, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1065',
      tarif: '590',
      category: '2',
      label: {
        de: 'Lichttherapie, pro 5 Minuten',
        fr: 'Thérapie par la lumière, par période de 5 minutes',
        it: 'Terapia con luce, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1066',
      tarif: '590',
      category: '2',
      label: {
        de: 'Lymphdrainage, manuelle, pro 5 Minuten',
        fr: 'Drainage lymphatique (manuel), par période de 5 minutes',
        it: 'Linfodrenaggio manuale, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1067',
      tarif: '590',
      category: '2',
      label: {
        de: 'Magnetfeldtherapie, pro 5 Minuten',
        fr:
          'Magnétothérapie/thérapie par champs magnétiques, par période de 5 minutes ',
        it: 'Magnetoterapia, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1068',
      tarif: '590',
      category: '2',
      label: {
        de: 'Maltherapie, pro 5 Minuten',
        fr: 'Thérapie par la peinture, par période de 5 minutes',
        it: 'Terapia della pittura, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1069',
      tarif: '590',
      category: '2',
      label: {
        de: 'Mesotherapie, pro 5 Minuten',
        fr: 'Mésothérapie, par période de 5 minutes',
        it: 'Mesoterapia, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1070',
      tarif: '590',
      category: '2',
      label: {
        de: 'Metamorphosis, pro 5 Minuten',
        fr: 'Massage métamorphique, par période de 5 minutes',
        it: 'Metamorfosi, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1071',
      tarif: '590',
      category: '2',
      label: {
        de: 'Moxibustion, pro 5 Minuten',
        fr: 'Moxibustion, par période de 5 minutes',
        it: 'Moxibustione, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1072',
      tarif: '590',
      category: '2',
      label: {
        de: 'Musiktherapie, pro 5 Minuten',
        fr: 'Musicothérapie, par période de 5 minutes',
        it: 'Musicoterapia, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1073',
      tarif: '590',
      category: '2',
      label: {
        de: 'Muskelreflexzonenmassage, pro 5 Minuten',
        fr: 'Massage des zones réflexes musculaires, par période de 5 minutes',
        it: 'Massaggio delle zone riflesse muscolari, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1074',
      tarif: '590',
      category: '2',
      label: {
        de: 'Myofunktionelle Therapie, pro 5 Minuten',
        fr: 'Thérapie myofonctionelle, par période de 5 minutes',
        it: 'Terapia miofunzionale, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1075',
      tarif: '590',
      category: '2',
      label: {
        de: 'Neuraltherapie, pro 5 Minuten',
        fr: 'Thérapie neurale, par période de 5 minutes',
        it: 'Terapia neurale, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1076',
      tarif: '590',
      category: '2',
      label: {
        de: 'Neurofeedback, pro 5 Minuten',
        fr: 'Neurofeedback, par période de 5 minutes',
        it: 'Neurofeedback, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1077',
      tarif: '590',
      category: '2',
      label: {
        de: 'Ohrakupunktur, pro 5 Minuten',
        fr: 'Acupuncture des oreilles, par période de 5 minutes  ',
        it: 'Agopuntura auricolare, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1079',
      tarif: '590',
      category: '2',
      label: {
        de: 'Ohrkerzen-Therapie, pro 5 Minuten',
        fr: 'Otothérapie par les bougies, par période de 5 minutes',
        it: 'Ototerapia con candele, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1080',
      tarif: '590',
      category: '2',
      label: {
        de: 'Organisch-rhythmische Bewegungsbildung Medau, pro 5 Minuten',
        fr:
          'Formation du mouvement rythmo-organique Medau, par période de 5 minutes',
        it: 'Terapia dei movimenti organico-ritmici Medau, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1081',
      tarif: '590',
      category: '2',
      label: {
        de: 'Ortho-Bionomy, pro 5 Minuten',
        fr: 'Ortho-Bionomy, par période de 5 minutes',
        it: 'Ortho-Bionomy, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1082',
      tarif: '590',
      category: '2',
      label: {
        de: 'Orthomolekulare Therapie, pro 5 Minuten',
        fr: 'Thérapie orthomoléculaire, par période de 5 minutes',
        it: 'Terapia ortomolecolare, ogni 5 min.'
      },
      description: {
        de:
          'Beinhaltet die orthomolekulare Beratung, ausgenommen orthomolekulare Präparate. Diese werden unter der Tarifziffer 1310 verrechnet.',
        fr:
          "Comprend la consultation orthomoléculaire, l'exclusion des préparations orthomoléculaires. Ceux-ci sonst facturés sous le numéro tarifaire 1310",
        it:
          'Include la consulenza ortomolecolare, escluse le preparazioni ortomolecolari. Questi saranno fatturati con numero di tariffa 1310'
      },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1084',
      tarif: '590',
      category: '2',
      label: {
        de: 'Ozontherapie, pro 5 Minuten',
        fr: 'Thérapie par l’ozone, par période de 5 minutes',
        it: 'Ozonoterapia, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1085',
      tarif: '590',
      category: '2',
      label: {
        de: 'Phytotherapie, pro 5 Minuten',
        fr: 'Phytothérapie, par période de 5 minutes',
        it: 'Fitoterapia, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1087',
      tarif: '590',
      category: '2',
      label: {
        de: 'Polarity, pro 5 Minuten',
        fr: 'Polarity, par période de 5 minutes',
        it: 'Polarity, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1088',
      tarif: '590',
      category: '2',
      label: {
        de: 'Posturale Integration, pro 5 Minuten',
        fr: 'Intégration posturale, par période de 5 minutes',
        it: 'Integrazione posturale, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1089',
      tarif: '590',
      category: '2',
      label: {
        de: 'Psychomotorik, pro 5 Minuten',
        fr: 'Psychomotricité, par période de 5 minutes',
        it: 'Psicomotricità, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1090',
      tarif: '590',
      category: '2',
      label: {
        de: 'Psychozonenmassage, pro 5 Minuten',
        fr: 'Massage des zones psychogènes, par période de 5 minutes',
        it: 'Massaggio delle zone psicogene, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1091',
      tarif: '590',
      category: '2',
      label: {
        de: 'Figurenspieltherapie, pro 5 Minuten',
        fr: 'Thérapie de théâtre de marionnettes,  par période de 5 minutes',
        it: 'Terapia con le marionette, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1092',
      tarif: '590',
      category: '2',
      label: {
        de: 'Qi-Gong, pro 5 Minuten',
        fr: 'Qi Gong, par période de 5 minutes',
        it: 'Qi-Gong, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1093',
      tarif: '590',
      category: '2',
      label: {
        de: 'Rebalancing, pro 5 Minuten',
        fr: 'Rebalancing, par période de 5 minutes',
        it: 'Rebalancing, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1094',
      tarif: '590',
      category: '2',
      label: {
        de: 'Rebirthing, pro 5 Minuten',
        fr: 'Thérapie par nouvelle naissance, par période de 5 minutes',
        it: 'Rebirthing, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1096',
      tarif: '590',
      category: '2',
      label: {
        de: 'Reiki, pro 5 Minuten',
        fr: 'Reiki, par période de 5 minutes',
        it: 'Reiki, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1097',
      tarif: '590',
      category: '2',
      label: {
        de: 'Rolfing / Strukturelle Integration, pro 5 Minuten',
        fr: 'Rolfing/intégration structurelle, par période de 5 minutes',
        it: 'Rolfing / Integrazione strutturale, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1098',
      tarif: '590',
      category: '2',
      label: {
        de: 'Rhythmische Massage, anthrop., pro 5 Minuten',
        fr: 'Massages rythmiques anthrop., par période de 5 minutes ',
        it: 'Massaggio ritmico, antroposofico, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1099',
      tarif: '590',
      category: '2',
      label: {
        de: 'Sauerstoff-Mehrschritt-Therapie, pro 5 Minuten',
        fr: 'Oxygénotherapie en plusieurs étapes, par période de 5 minutes',
        it: 'Ossigenoterapia in diverse tappe, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1100',
      tarif: '590',
      category: '2',
      label: {
        de: 'Shiatsu, pro 5 Minuten',
        fr: 'Shiatsu, par période de 5 minutes',
        it: 'Shiatsu, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1101',
      tarif: '590',
      category: '2',
      label: {
        de: 'Shin Tai, pro 5 Minuten',
        fr: 'Shin Tai, par période de 5 minutes',
        it: 'Shin Tai, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1102',
      tarif: '590',
      category: '2',
      label: {
        de: 'Sophrologie / Sophrologie Caycedienne, pro 5 Minuten',
        fr: 'Sophrologie / Sophrologie Caycédienne, par période de 5 minutes',
        it: 'Sofrologia, Sofrologia Caycedienne, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1103',
      tarif: '590',
      category: '2',
      label: {
        de: 'Schröpfen, pro 5 Minuten',
        fr: 'Ventouses, par période de 5 minutes',
        it: 'Coppettazione, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '2016-12-31'
    },
    {
      id: '1104',
      tarif: '590',
      category: '2',
      label: {
        de: 'Sumathu-Therapie, pro 5 Minuten',
        fr: 'Thérapie Sumathu, par période de 5 minutes',
        it: 'Sumathu, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1105',
      tarif: '590',
      category: '2',
      label: {
        de: 'Sympathico-Therapie, pro 5 Minuten',
        fr: 'Sympathicothérapie, par période de 5 minutes',
        it: 'Simpaticoterapia, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1106',
      tarif: '590',
      category: '2',
      label: {
        de: 'Tai-Chi, pro 5 Minuten',
        fr: 'Tai Chi, par période de 5 minutes',
        it: 'Tai-Chi, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1108',
      tarif: '590',
      category: '2',
      label: {
        de: 'Tanztherapie, pro 5 Minuten',
        fr: 'Thérapie par la danse, par période de 5 minutes',
        it: 'Terapia della danza, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1111',
      tarif: '590',
      category: '2',
      label: {
        de: 'Thai-Massage, pro 5 Minuten',
        fr: 'Massage thaï, par période de 5 minutes',
        it: 'Massaggio Thai, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1113',
      tarif: '590',
      category: '2',
      label: {
        de: 'Thermographie, pro 5 Minuten',
        fr: 'Thermographie, par période de 5 minutes',
        it: 'Termografia, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1114',
      tarif: '590',
      category: '2',
      label: {
        de: 'Tibetische Medizin, Behandlung/Konsultation, pro 5 Minuten',
        fr:
          'Médecine tibétaine, traitement/consultation, par période de 5 minutes',
        it: 'Medicina tibetana, trattamento/consultazione, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1115',
      tarif: '590',
      category: '2',
      label: {
        de: 'Touch for Health, pro 5 Minuten',
        fr: 'Touch for Health, par période de 5 minutes',
        it: 'Touch for Health, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1117',
      tarif: '590',
      category: '2',
      label: {
        de: 'Trager, pro 5 Minuten',
        fr: 'Massage selon Trager, par période de 5 minutes',
        it: 'Metodo Trager, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1118',
      tarif: '590',
      category: '2',
      label: {
        de: 'Ultraviolettbestrahlung - Blut, pro 5 Minuten',
        fr: 'Thérapie par du sang irradié (UV), par période de 5 minutes',
        it: 'Terapia con sangue irradiato UV, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1120',
      tarif: '590',
      category: '2',
      label: {
        de: 'Vitalpraktik nach Vuille, pro 5 Minuten',
        fr: 'Vitalpratique selon Vuille, par période de 5 minutes',
        it: 'Vitalpratica di Vuille, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1121',
      tarif: '590',
      category: '2',
      label: {
        de: 'Wickel/Umschläge/Fango, pro 5 Minuten',
        fr: 'Cataplasmes/enveloppements/fango, par période de 5 minutes',
        it: 'Cataplasmi/impacchi/fango, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1122',
      tarif: '590',
      category: '2',
      label: {
        de: 'WS-Basis Ausgleich/WS-Basis-Therapie, pro 5 Minuten',
        fr: 'Équilibration vertébrale, par période de 5 minutes',
        it:
          'Terapia di compensazione della base della colonna vertebrale, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1123',
      tarif: '590',
      category: '2',
      label: {
        de: 'Zilgrei, pro 5 Minuten',
        fr: 'Zilgrei, par période de 5 minutes',
        it: 'Metodo Zilgrei, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1127',
      tarif: '590',
      category: '2',
      label: {
        de: 'Hömöopathie - Repertorisation, pro 5 Minuten',
        fr: 'Homöopathie - Répertorisation, par période de 5 minutes',
        it: 'Omeopatia, repertorizzazione, ogni 5 min.'
      },
      description: {
        de:
          'Die Repertorisation, unabhängig der An- oder Abwesenheit des Patienten wird unter dieser Tarifziffer abgerechnet.',
        fr:
          "La répertorisation, indépendamment de la présence ou de l'absence du patient, est facturée sous ce code tarifaire.",
        it:
          "L'repertorizzazione, indipendentemente dalla presenza o meno del paziente, viene fatturata con questo codice tariffa"
      },
      validFrom: '2012-02-01',
      validTo: '9998-12-31'
    },
    {
      id: '1128',
      tarif: '590',
      category: '2',
      label: {
        de: 'Adveda-Eugemed-Therapie pro 5 Minuten',
        fr: 'Thérapie Adveda-Eugemed, par période de 5 minutes',
        it: 'Terapia Adveda-Eugemed, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1131',
      tarif: '590',
      category: '2',
      label: {
        de: 'Gestaltungstherapie, pro 5 Minuten',
        fr: 'Thérapie à médiation plastique, par période de 5 minutes',
        it: 'Terapia di modellagio, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2014-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1132',
      tarif: '590',
      category: '2',
      label: {
        de: 'Intermediale Therapie, pro 5 Minuten',
        fr: 'Thérapie intermédiale, par période de 5 minutes',
        it: 'Terapia intermediale, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2014-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1133',
      tarif: '590',
      category: '2',
      label: {
        de: 'Meridian-Therapie, pro 5 Minuten',
        fr: 'Thérapie des méridiens, par période de 5 minutes',
        it: 'Terapia dei meridiani, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1134',
      tarif: '590',
      category: '2',
      label: {
        de: 'Reflexzonentherapie, pro 5 Minuten',
        fr: 'Réflexothérapie, par période de 5 minutes',
        it: 'Riflessoterapia, ogni 5 min.'
      },
      description: {
        de:
          'Beinhaltet Körperreflexzonen, Muskelreflexzonen, und Mikrosysteme wie Ohren, Hände und Füsse',
        fr:
          'Comprend le massage des zones réflexes du corps, des muscles et des microsystèmes comme les oreilles, les mains et les pieds.',
        it:
          'Include riflessologia del corpo, riflessologia muscolare e microsistemi come orecchie, mani e piedi'
      },
      validFrom: '2014-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1140',
      tarif: '590',
      category: '2',
      label: {
        de: 'Microkinesitherapie, pro 5 Minuten',
        fr: 'Microkinésithérapie, par période de 5 minutes',
        it: 'Microkinésithérapie, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1142',
      tarif: '590',
      category: '2',
      label: {
        de: 'Spagyrik, pro 5 Min.',
        fr: 'Spagyrie,  par période de 5 minutes',
        it: 'Spagyrie, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1141',
      tarif: '590',
      category: '2',
      label: {
        de: 'Dorn-/Breuss-Therapie, pro 5 Minuten',
        fr: 'Thérapie Dorn/Breuss,  par période de 5 minutes',
        it: 'Terapia Dorn/Breuss, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1143',
      tarif: '590',
      category: '2',
      label: {
        de: 'Cantharidenpflaster, pro 5 Min',
        fr: 'Thérapie Cantharide, par période de 5 minutes',
        it: 'La terapia Cantharide, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2016-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1144',
      tarif: '590',
      category: '2',
      label: {
        de: 'Entwicklungs- und Lerntherapie nach PäPKi, pro 5 Minuten',
        fr:
          "Thérapie du développement et de l'apprentissage selon PäPKi, par période de 5 minutes",
        it: 'Terapia di sviluppo e apprendimento secondo PäPKi, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2020-01-01',
      validTo: '9998-12-31'
    },

    {
      id: '1201',
      tarif: '590',
      category: '2',
      label: {
        de: 'Dramatherapie, pro 5 Minuten',
        fr: 'Thérapie par le drame, par période de 5 minutes',
        it: 'Drammaterapia, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2016-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1202',
      tarif: '590',
      category: '2',
      label: {
        de: 'Therapeutische Sprachgestaltung, pro 5 Minuten',
        fr: 'Art de parole thérapeutique, par période de 5 minutes',
        it: 'Arte della parola terapeutica, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2016-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1203',
      tarif: '590',
      category: '2',
      label: {
        de: 'Osteopathie, pro 5 Minuten',
        fr: 'Ostéopathie, par période de 5 minutes',
        it: 'Osteopatia, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2016-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1204',
      tarif: '590',
      category: '2',
      label: {
        de: 'Etiopathie, pro 5 Minuten',
        fr: 'Etiopathie, par période de 5 minutes',
        it: 'Etiopatia, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2016-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1205',
      tarif: '590',
      category: '2',
      label: {
        de: 'Ausleitende Verfahren, pro 5 Minuten',
        fr: 'Méthodes de détoxication, par période de 5 minutes',
        it: 'Terapie devianti e ablative, ogni 5 min.'
      },
      description: {
        de:
          'Beinhaltet Schröpfen, Baunscheidtieren, Guasha, Purgieren, Aderlass, etc.',
        fr:
          'Comprend les ventouses, la Méthode Baunscheidt, le Gua Sha, purger, saignée, etc.',
        it:
          'Comprende salassi, Metodo Baunscheidt, Guasha, purgare, salasso, etc.'
      },
      validFrom: '2017-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1206',
      tarif: '590',
      category: '2',
      label: {
        de: 'Ernährungstherapie, pro 5 Minuten',
        fr: 'Thérapie nutritionnelle, par période de 5 minutes',
        it: 'terapia nutrizionale, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2017-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1207',
      tarif: '590',
      category: '2',
      label: {
        de: 'Ordnungstherapie / Diätetik, pro 5 Minuten',
        fr: "Thérapie de l'ordre / Diététique, par période de 5 minutes",
        it: "Terapia dell'ordine / Dietetica, ogni 5 min."
      },
      description: {
        de:
          'Für Naturheilpraktiker mit eidg. Diplom: Beinhaltet Verfahren wie Hydrotherapie, Purgieren, nasale Behandlungen, Wickel, Umschläge und Fango.',
        fr:
          "Pour les praticiens en médecine naturelle avec diplôme fédéral: comprend des méthodes telles que l'hydrothérapie, la purge, les traitements nasaux, les cataplasmes/enveloppements/fango.",
        it:
          "Per Naturopati con diploma federale: comprende  metodi come l'idroterapia, purgare, trattamenti nasali, impacchi, compressioni e fango."
      },
      validFrom: '2017-01-01',
      validTo: '2018-12-31'
    },
    {
      id: '1209',
      tarif: '590',
      category: '2',
      label: {
        de: 'Ayurvedische Güsse, pro 5 Minuten',
        fr: 'Jets ayurvédique, par période de 5 minutes',
        it: 'Getto ayurvedico, ogni 5 min.'
      },
      description: {
        de:
          'Beinhaltet Ganzkörper Ölgussbehandlung, Stirnguss, Lokale Intensiv-Ölanwendung (Kopf, Wirbelsäule, Brustbereich, Knie), Augenbehandlung, Ohrfüllung',
        fr:
          "Comprend le traitement par coulées d'huile sur tout le corps, coulée sur le front, l'application intensive locale d'huile (tête, colonne vertébrale, poitrine, genou), le traitement des yeux, le remplissage de l'oreille.",
        it:
          "Comprende trattamento del corpo completo con getto d'olio, getto sulla fronte, applicazione intensiva locale con olio (testa, colonna vertebrale, petto, ginocchio), trattamento degli occhi, riempimento dell'orecchio"
      },
      validFrom: '2017-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1210',
      tarif: '590',
      category: '2',
      label: {
        de: 'Spiraldynamik, pro 5 Min.',
        fr: 'Spiraldynamik,  par période de 5 minutes',
        it: 'Spiraldynamik, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2017-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1214',
      tarif: '590',
      category: '2',
      label: {
        de: 'Funktionelle Orthonomie und Integration, pro 5 Minuten',
        fr: 'Orthonomie fonctionnelle et intégration, par période de 5 minutes',
        it: 'Ortonomia funzionale e integrazione, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2019-01-01',
      validTo: '9998-12-31'
    },

    {
      id: '1300',
      tarif: '590',
      category: '3',
      label: {
        de: 'Magistralrezeptur',
        fr: 'Préparation magistrale',
        it: 'Ricetta magistrale'
      },
      description: {
        de: 'Details zur Magistralrezeptur müssen dargelegt werden',
        fr: 'La préparation magistrale doit être détaillée. ',
        it: 'Devono essere esposti i dettagli della ricetta magistrale'
      },
      validFrom: '2016-01-01',
      validTo: '2017-12-31'
    },
    {
      id: '1301',
      tarif: '590',
      category: '3',
      label: {
        de: 'Individualrezeptur',
        fr: 'Préparation individuelle',
        it: 'Ricetta individuale'
      },
      description: {
        de: 'Details zur Individualrezeptur müssen dargelegt werden',
        fr: 'La préparation individuelle doit être détaillée. ',
        it: 'Devono essere esposti i dettagli della ricetta individuale '
      },
      validFrom: '2016-01-01',
      validTo: '2017-12-31'
    },
    {
      id: '1310',
      tarif: '590',
      category: '3',
      label: {
        de: 'Arzneimittel Komplementärmedizin',
        fr: 'Remèdes médecine complémentaire',
        it: 'Rimedi medicina complementare'
      },
      description: {
        de:
          'Sämtliche Arzneimittel der Komplementärmedizin werden nach folgender Regel erfasst: «Produktname bzw. Verwendungszweck, Hersteller, Menge (z.B. Packungsgrösse) und die Darreichungsform», zum Beispiel «UMCKALOABO Lösung, Schwabe, 50 ml» bzw. «Phytotherapeutika Husten, Hänseler, 50 ml»',
        fr:
          "Tous les médicaments de médecine complémentaire sont enrigistrés selon à la règle suivante: «nom du produit resp. utilisation, fabricant, quantité (p. ex. taille de l'emballage) et forme posologique» Exemple: «UMCKALOABO Solution, Schwabe, 50 ml» resp. «Phytothérapeutiques toux, Hänseler, 50 ml»",
        it:
          'Tutti i medicinali della medicina complementare sono registrati secondo la regola seguente: «nome del prodotto risp. uso, produttore, quantità (ad es. grandezza dell’imballaggio), forma farmaceutica», ad esempio «UMCKALOABO Soluzione, Schwabe, 50 ml» risp. «Fitoterapici tosse, Hänseler, 50 ml»'
      },
      validFrom: '2018-01-01',
      validTo: '9998-12-31'
    },

    {
      id: '1302',
      tarif: '590',
      category: '4',
      label: {
        de: 'Komplementärmedizinische Laborleistungen',
        fr: 'Services de laboratoire médecine complémentaires',
        it: 'Servizi di laboratorio medicina complementare'
      },
      description: {
        de:
          "Sämtliche Laborleistungen der Komplementärmedizin werden nach folgender Regel erfasst: «ZSR-Nr. oder Name und Ort durchführendes Labor, Ausgangsmaterial, durchgeführte Untersuchung» Zum Beispiel 'ZSR-Nr. XY, Stuhl, Transglutaminase-AK'",
        fr:
          "Tous les services de laboratoire en médecine complémentaire sont enregistrés selon à la règle suivante: 'Numéro RCC ou nom et adresse du laboratoire, matériel d'origine, essais effectués' Par exemple, 'RCC No. XY, fèces, transglutaminase AC.'",
        it:
          "Tutti i servizi di laboratorio in medicina complementare sono registrati secondo la regola seguente: 'RCC No o nome e ubicazione del laboratorio, materiale di partenza, test effettuati' Per esempio, 'RCC No. XY, feci, transglutaminasi AC.'."
      },
      validFrom: '2017-01-01',
      validTo: '9998-12-31'
    },

    {
      id: '1257',
      tarif: '590',
      category: '5.0',
      label: {
        de:
          'Koordination der Behandlung mit anderen Gesundheitsfachpersonen, pro 5 Minuten',
        fr:
          "Coordination du traitement avec d'autres professionnels de la santé, par période de 5 minutes",
        it:
          'Coordinamento del trattamento con altri professionisti della salute, ogni 5 min.'
      },
      description: {
        de:
          'Diese Tarifziffer darf nur von Naturheilpraktikern mit eidgenössischem Diplom verwendet werden. Gilt für persönliche oder telefonische Besprechungen von freischaffenden Leistungserbringer mit Gesundheitsfachpersonen (wie Ärzte, Therapeuten, Spitexdienste) in Abwesenheit des Patienten. Gilt nicht für das Aktenstudium oder Besprechungen die in Zusammenhang mit der Erstellung von Berichten stehen.',
        fr:
          "Ce numéros tarifaires ne peut être utilisé que par les naturopathes avec diplôme fédéral. S'applique aux rencontres personnelles ou téléphoniques entre des fournisseurs de services indépendants et des professionnels de santé (médecins, thérapeutes, services Spitex) en l'absence du patient. Ne s'applique pas à l'étude des dossiers ou aux réunions dans le cadre de la préparation des rapports.",
        it:
          'Questa cifre tariffarie può essere utilizzata solo da naturopati con diploma federale. Si applica agli incontri personali o telefonici tra fornitori di servizi freelance e professionisti della salute (come medici, terapisti, servizi Spitex) in assenza del paziente. Non si applica allo studio di fascicoli o riunioni in relazione alla preparazione di relazioni.'
      },
      validFrom: '2020-01-01',
      validTo: '9998-12-31'
    },

    {
      id: '1021',
      tarif: '590',
      category: '5.1',
      label: {
        de: 'Ayurveda-Massage, pro 5 Minuten',
        fr: 'Massage ayurvédique, par période de 5 minutes',
        it: 'Massaggio ayurvedico, ogni 5 min.'
      },
      description: {
        de:
          'Beinhaltet Ganz- und Teilkörper Ölbehandlungen (Kopf, Rücken, Füsse, Vitalpunkte), Ganzkörper-Behandlungen mit Pulver und Pasten',
        fr:
          "Comprend traitements à l'huile d'une partie ou de tout le corps (tête, dos, pieds, points vitaux), traitements corporels avec des poudres et pâtes.",
        it:
          'Comprende trattamenti completi e parziali del corpo con oli (testa, schiena, piedi, punti vitali), trattamenti completi con paste e polveri'
      },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1205',
      tarif: '590',
      category: '5.1',
      label: {
        de: 'Ausleitende Verfahren, pro 5 Minuten',
        fr: 'Méthodes de détoxication, par période de 5 minutes',
        it: 'Terapie devianti e ablative, ogni 5 min.'
      },
      description: {
        de:
          'Beinhaltet Schröpfen, Baunscheidtieren, Guasha, Purgieren, Aderlass, etc.',
        fr:
          'Comprend les ventouses, la Méthode Baunscheidt, le Gua Sha, purger, saignée, etc.',
        it:
          'Comprende salassi, Metodo Baunscheidt, Guasha, purgare, salasso, etc.'
      },
      validFrom: '2017-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1206',
      tarif: '590',
      category: '5.1',
      label: {
        de: 'Ernährungstherapie, pro 5 Minuten',
        fr: 'thérapie nutritionnelle, par période de 5 minutes',
        it: 'terapia nutrizionale, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2017-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1208',
      tarif: '590',
      category: '5.1',
      label: {
        de: 'Arzneimitteltherapie, pro 5 Minuten',
        fr: 'Traitement médicamenteux, par période de 5 minutes',
        it: 'terapia medicamentosa, ogni 5 min.'
      },
      description: {
        de:
          'Für Naturheilpraktiker mit eidg. Diplom: Komplementärmedizinische Arzneimitteltherapie (Therapie, Verordnung, Mittelwahl), wie Phytotherapie, funktionelle Homöopathie, Bachblüten, Spagyrik, Biochemie nach Schüssler, etc.  (Heilmittel separat verrechnet)',
        fr:
          "Pour les praticiens en médecine naturelle avec diplôme fédéral: Thérapie médicamenteuse de la médecine complémentaire (thérapie, ordonnance, sélection), comme la phytothérapie, l'homéopathie fonctionnelle, les fleurs de Bach, la spagyrie, la biochimie selon Schüssler, etc. (médicament facturé séparément).",
        it:
          'Per Naturopati con diploma federale: Medicina complementare della terapia medicamentosa (terapia, prescrizione, selezione rimedio), come la fitoterapia, omeopatia funzionale, fiori di Bach, spagirica, biochimica secondo Schuessler, ecc (fatturare il rimedio a parte)'
      },
      validFrom: '2017-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1209',
      tarif: '590',
      category: '5.1',
      label: {
        de: 'Ayurvedische Güsse, pro 5 Minuten',
        fr: 'Jets ayurvédique, par période de 5 minutes',
        it: 'Getto ayurvedico, ogni 5 min.'
      },
      description: {
        de:
          'Beinhaltet Ganzkörper Ölgussbehandlung, Stirnguss, Lokale Intensiv-Ölanwendung (Kopf, Wirbelsäule, Brustbereich, Knie), Augenbehandlung, Ohrfüllung',
        fr:
          "Comprend le traitement par coulées d'huile sur tout le corps, coulée sur le front, l'application intensive locale d'huile (tête, colonne vertébrale, poitrine, genou), le traitement des yeux, le remplissage de l'oreille.",
        it:
          "Comprende trattamento del corpo completo con getto d'olio, getto sulla fronte, applicazione intensiva locale con olio (testa, colonna vertebrale, petto, ginocchio), trattamento degli occhi, riempimento dell'orecchio"
      },
      validFrom: '2017-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1212',
      tarif: '590',
      category: '5.1',
      label: {
        de: 'Ordnungstherapie, pro 5 Minuten',
        fr: "Thérapie de l'ordre, par période de 5 minutes",
        it: "Terapia dell'ordine, ogni 5 min."
      },
      description: {
        de:
          'Beinhaltet Verfahren und Massnahmen der Lebensordnung gestützt auf die jeweilige Fachrichtung (z.B. Humoralmedizin oder 5-Elemente-Lehre)',
        fr:
          'Comprend des procédures et des mesures de Hygiène de vie en se basant sur la disciplines respective (p. ex. médecine humorale ou enseignement à 5 éléments)',
        it:
          "Comprende procedure e misure dell'ordine di vita in base indirizzi specifici (ad es. medicina umorale o insegnamento a 5 elementi)"
      },
      validFrom: '2019-01-01',
      validTo: '9998-12-31'
    },

    {
      id: '1057',
      tarif: '590',
      category: '5.2',
      label: {
        de: 'Homöopathie, Behandlung/Konsultation, pro 5 Minuten',
        fr: 'Homéopathie, Traitement/Consultation, par période de 5 minutes',
        it: 'Homéopathie, Traitement/Consultation, par période de 5 minutes'
      },
      description: {
        de:
          'Diese Tarifziffer beinhaltet alle fachrichtungsspezifischen Verrichtungen im direkten Kontakt mit dem Patienten (homöopathische Anamnese, inkl. telefonische Konsultation), ausgenommen die Repertorisation (siehe Tarifziffer 1127)',
        fr:
          "Ce code tarifaire comprend toutes les activités spécifiques à une spécialité en contact direct avec le patient (anamnèse homéopathique, y compris la consultation téléphonique), à l'exception de la répertorisation (voir code tarifaire 1127).",
        it:
          'Questa codice tariffa comprende tutte le attività specialistiche specifiche a diretto contatto con il paziente (anamnesi omeopatica, compresa la consulenza telefonica), ad eccezione della repertorizzazione (vedi codice tariffa 1127).'
      },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1127',
      tarif: '590',
      category: '5.2',
      label: {
        de: 'Hömöopathie - Repertorisation, pro 5 Minuten',
        fr: 'Homöopathie - Répertorisation, par période de 5 minutes',
        it: 'Omeopatia, repertorizzazione, ogni 5 min.'
      },
      description: {
        de:
          'Die Repertorisation, unabhängig der An- oder Abwesenheit des Patienten wird unter dieser Tarifziffer abgerechnet.',
        fr:
          "La répertorisation, indépendamment de la présence ou de l'absence du patient, est facturée sous ce code tarifaire.",
        it:
          "L'repertorizzazione, indipendentemente dalla presenza o meno del paziente, viene fatturata con questo codice tariffa."
      },
      validFrom: '2012-02-01',
      validTo: '9998-12-31'
    },
    {
      id: '1212',
      tarif: '590',
      category: '5.2',
      label: {
        de: 'Ordnungstherapie, pro 5 Minuten',
        fr: "Thérapie de l'ordre, par période de 5 minutes",
        it: "Terapia dell'ordine, ogni 5 min."
      },
      description: {
        de:
          'Beinhaltet Verfahren und Massnahmen der Lebensordnung gestützt auf die jeweilige Fachrichtung (z.B. Humoralmedizin oder 5-Elemente-Lehre)',
        fr:
          'Comprend des procédures et des mesures de Hygiène de vie en se basant sur la disciplines respective (p. ex. médecine humorale ou enseignement à 5 éléments)',
        it:
          "Comprende procedure e misure dell'ordine di vita in base indirizzi specifici (ad es. medicina umorale o insegnamento a 5 elementi)"
      },
      validFrom: '2019-01-01',
      validTo: '9998-12-31'
    },

    {
      id: '1004',
      tarif: '590',
      category: '5.3',
      label: {
        de: 'Akupunktur, pro 5 Minuten',
        fr: 'Acupuncture, par période de 5 minutes',
        it: 'Agopuntura, ogni 5 min.'
      },
      description: {
        de:
          'Beinhaltet Elektroakupunktur, Laser-Akupunktur, Moxibustion, Ohrakupunktur',
        fr:
          "Comprend l'électroacupuncture, l'acupuncture au laser, la moxibustion, l'acupuncture.",
        it:
          'Comprende elettroagopuntura, agopuntura al laser, moxibustione, agopuntura auricolare'
      },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1007',
      tarif: '590',
      category: '5.3',
      label: {
        de: 'Tui-Na/An-Mo, pro 5 Minuten',
        fr: 'Tui-Na/An-Mo, par période de 5 minutes',
        it: 'Tui-Na/An-Mo, ogni 5 min.'
      },
      description: {
        de: 'Beinhaltet Moxibustion',
        fr: 'Comprend moxibustion',
        it: 'Comprende moxibustione'
      },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1205',
      tarif: '590',
      category: '5.3',
      label: {
        de: 'Ausleitende Verfahren, pro 5 Minuten',
        fr: 'Méthodes de détoxication, par période de 5 minutes',
        it: 'Terapie devianti e ablative, ogni 5 min.'
      },
      description: {
        de:
          'Beinhaltet Schröpfen, Baunscheidtieren, Guasha, Purgieren, Aderlass, etc.',
        fr: 'Comprend les ventouses, la méthode Baunscheidt, le Gua Sha, etc.',
        it: 'Comprende salassi, metodo Baunscheidt, Guasha, purgare, etc.'
      },
      validFrom: '2017-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1206',
      tarif: '590',
      category: '5.3',
      label: {
        de: 'Ernährungstherapie, pro 5 Minuten',
        fr: 'thérapie nutritionnelle, par période de 5 minutes',
        it: 'terapia nutrizionale, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2017-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1208',
      tarif: '590',
      category: '5.3',
      label: {
        de: 'Arzneimitteltherapie, pro 5 Minuten',
        fr: 'Traitement médicamenteux, par période de 5 minutes',
        it: 'terapia medicamentosa, ogni 5 min.'
      },
      description: {
        de:
          'Für Naturheilpraktiker mit eidg. Diplom: Komplementärmedizinische Arzneimitteltherapie (Therapie, Verordnung, Mittelwahl), wie Phytotherapie, funktionelle Homöopathie, Bachblüten, Spagyrik, Biochemie nach Schüssler, etc.  (Heilmittel separat verrechnet)',
        fr:
          "Pour les praticiens en médecine naturelle avec diplôme fédéral: Thérapie médicamenteuse de la médecine complémentaire (thérapie, ordonnance, sélection), comme la phytothérapie, l'homéopathie fonctionnelle, les fleurs de Bach, la spagyrie, la biochimie selon Schüssler, etc. (médicament facturé séparément).",
        it:
          'Per Naturopati con diploma federale: Medicina complementare della terapia medicamentosa (terapia, prescrizione, selezione rimedio), come la fitoterapia, omeopatia funzionale, fiori di Bach, spagirica, biochimica secondo Schuessler, ecc (fatturare il rimedio a parte)'
      },
      validFrom: '2017-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1212',
      tarif: '590',
      category: '5.3',
      label: {
        de: 'Ordnungstherapie, pro 5 Minuten',
        fr: "Thérapie de l'ordre, par période de 5 minutes",
        it: "Terapia dell'ordine, ogni 5 min."
      },
      description: {
        de:
          'Beinhaltet Verfahren und Massnahmen der Lebensordnung gestützt auf die jeweilige Fachrichtung (z.B. Humoralmedizin oder 5-Elemente-Lehre)',
        fr:
          'Comprend des procédures et des mesures de Hygiène de vie en se basant sur la disciplines respective (p. ex. médecine humorale ou enseignement à 5 éléments)',
        it:
          "Comprende procedure e misure dell'ordine di vita in base indirizzi specifici (ad es. medicina umorale o insegnamento a 5 elementi)"
      },
      validFrom: '2019-01-01',
      validTo: '9998-12-31'
    },

    {
      id: '1027',
      tarif: '590',
      category: '5.4',
      label: {
        de: 'Bioresonanz-Therapie, pro 5 Minuten',
        fr: 'Biorésonance, par période de 5 minutes',
        it: 'Biorisonanza, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1066',
      tarif: '590',
      category: '5.4',
      label: {
        de: 'Lymphdrainage, manuelle, pro 5 Minuten',
        fr: 'Drainage lymphatique (manuel), par période de 5 minutes',
        it: 'Linfodrenaggio manuale, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1134',
      tarif: '590',
      category: '5.4',
      label: {
        de: 'Reflexzonentherapie, pro 5 Minuten',
        fr: 'Réflexothérapie, par période de 5 minutes',
        it: 'Riflessoterapia, ogni 5 min.'
      },
      description: {
        de:
          'Beinhaltet Körperreflexzonen, Muskelreflexzonen, und Mikrosysteme wie Ohren, Hände und Füsse',
        fr:
          'Comprend le massage des zones réflexes du corps, des muscles et des microsystèmes comme les oreilles, les mains et les pieds.',
        it:
          'Include riflessologia del corpo, riflessologia muscolare e microsistemi come orecchie, mani e piedi'
      },
      validFrom: '2014-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1141',
      tarif: '590',
      category: '5.4',
      label: {
        de: 'Dorn-/Breuss-Therapie, pro 5 Minuten',
        fr: 'Thérapie Dorn/Breuss,  par période de 5 minutes',
        it: 'Terapia Dorn/Breuss, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1205',
      tarif: '590',
      category: '5.4',
      label: {
        de: 'Ausleitende Verfahren, pro 5 Minuten',
        fr: 'Méthodes de détoxication, par période de 5 minutes',
        it: 'Terapie devianti e ablative, ogni 5 min.'
      },
      description: {
        de:
          'Beinhaltet Schröpfen, Baunscheidtieren, Guasha, Purgieren, Aderlass, etc.',
        fr: 'Comprend les ventouses, la méthode Baunscheidt, le Gua Sha, etc.',
        it: 'Comprende salassi, metodo Baunscheidt, Guasha, purgare, etc.'
      },
      validFrom: '2017-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1208',
      tarif: '590',
      category: '5.4',
      label: {
        de: 'Arzneimitteltherapie, pro 5 Minuten',
        fr: 'Traitement médicamenteux, par période de 5 minutes',
        it: 'terapia medicamentosa, ogni 5 min.'
      },
      description: {
        de:
          'Für Naturheilpraktiker mit eidg. Diplom: Komplementärmedizinische Arzneimitteltherapie (Therapie, Verordnung, Mittelwahl), wie Phytotherapie, funktionelle Homöopathie, Bachblüten, Spagyrik, Biochemie nach Schüssler, etc.  (Heilmittel separat verrechnet)',
        fr:
          "Pour les praticiens en médecine naturelle avec diplôme fédéral: Thérapie médicamenteuse de la médecine complémentaire (thérapie, ordonnance, sélection), comme la phytothérapie, l'homéopathie fonctionnelle, les fleurs de Bach, la spagyrie, la biochimie selon Schüssler, etc. (médicament facturé séparément).",
        it:
          'Per Naturopati con diploma federale: Medicina complementare della terapia medicamentosa (terapia, prescrizione, selezione rimedio), come la fitoterapia, omeopatia funzionale, fiori di Bach, spagirica, biochimica secondo Schuessler, ecc (fatturare il rimedio a parte)'
      },
      validFrom: '2017-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1212',
      tarif: '590',
      category: '5.4',
      label: {
        de: 'Ordnungstherapie, pro 5 Minuten',
        fr: "Thérapie de l'ordre, par période de 5 minutes",
        it: "Terapia dell'ordine, ogni 5 min."
      },
      description: {
        de:
          'Beinhaltet Verfahren und Massnahmen der Lebensordnung gestützt auf die jeweilige Fachrichtung (z.B. Humoralmedizin oder 5-Elemente-Lehre)',
        fr:
          'Comprend des procédures et des mesures de Hygiène de vie en se basant sur la disciplines respective (p. ex. médecine humorale ou enseignement à 5 éléments)',
        it:
          "Comprende procedure e misure dell'ordine di vita in base indirizzi specifici (ad es. medicina umorale o insegnamento a 5 elementi)"
      },
      validFrom: '2019-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1213',
      tarif: '590',
      category: '5.4',
      label: {
        de: 'Massagetechniken, pro 5 Minuten',
        fr: 'Technique de massage, par période de 5 minutes',
        it: 'Tecniche di massaggio, ogni 5 min.'
      },
      description: {
        de:
          'Beinhaltet Bindegewebs-Massage, Colon-Massage, klassische Massage, Triggerpunkt-Massage',
        fr:
          'Comprend le massage du tissu conjonctif, le massage du côlon, le massage classique,  le massage des points trigger.',
        it:
          'Comprende massaggio del tessuto connettivo, massaggio del colon, massaggio classico, massaggio dei punti trigger'
      },
      validFrom: '2019-01-01',
      validTo: '9998-12-31'
    },

    {
      id: '1257',
      tarif: '590',
      category: '6.0',
      label: {
        de:
          'Koordination der Behandlung mit anderen Gesundheitsfachpersonen, pro 5 Minuten',
        fr:
          "Coordination du traitement avec d'autres professionnels de la santé, par période de 5 minutes",
        it:
          'Coordinamento del trattamento con altri professionisti della salute, ogni 5 min.'
      },
      description: {
        de:
          'Diese Tarifziffer darf nur von Naturheilpraktikern mit eidgenössischem Diplom verwendet werden. Gilt für persönliche oder telefonische Besprechungen von freischaffenden Leistungserbringer mit Gesundheitsfachpersonen (wie Ärzte, Therapeuten, Spitexdienste) in Abwesenheit des Patienten. Gilt nicht für das Aktenstudium oder Besprechungen die in Zusammenhang mit der Erstellung von Berichten stehen.',
        fr:
          "Ce numéros tarifaires ne peut être utilisé que par les naturopathes avec diplôme fédéral. S'applique aux rencontres personnelles ou téléphoniques entre des fournisseurs de services indépendants et des professionnels de santé (médecins, thérapeutes, services Spitex) en l'absence du patient. Ne s'applique pas à l'étude des dossiers ou aux réunions dans le cadre de la préparation des rapports.",
        it:
          'Questa cifre tariffarie può essere utilizzata solo da naturopati con diploma federale. Si applica agli incontri personali o telefonici tra fornitori di servizi freelance e professionisti della salute (come medici, terapisti, servizi Spitex) in assenza del paziente. Non si applica allo studio di fascicoli o riunioni in relazione alla preparazione di relazioni.'
      },
      validFrom: '2020-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1003',
      tarif: '590',
      category: '6.1',
      label: {
        de: 'Akupressur, pro 5 Minuten',
        fr: 'Acupressure, par période de 5 minutes',
        it: 'Agopressione, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1006',
      tarif: '590',
      category: '6.2',
      label: {
        de: 'Alexander-Technik, pro 5 Minuten',
        fr: 'Technique Alexander, par période de 5 minutes',
        it: 'Tecnica Alexander, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1005',
      tarif: '590',
      category: '6.3',
      label: {
        de: 'APM-Therapie (Akupunktmassage-Therapie), pro 5 Minuten',
        fr:
          "APM thérapie (Thérapie par le massage sur méridiens d'acupuncture), par période de 5 minutes",
        it:
          'APM terapia (Terapia per il massaggio su meridiani d’agopuntura), ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1012',
      tarif: '590',
      category: '6.4',
      label: {
        de: 'Atemtherapie, pro 5 Minuten',
        fr: 'Thérapie respiratoire, par période de 5 minutes',
        it: 'Terapia respiratoria, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1215',
      tarif: '590',
      category: '6.5',
      label: {
        de: 'Ayurveda Therapie, pro 5 Minuten',
        fr: 'Ayurvéda thérapie, par période de 5 minutes',
        it: 'Ayurveda terapia, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2019-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1216',
      tarif: '590',
      category: '6.6',
      label: {
        de: 'Bewegungs- und Körpertherapie, pro 5 Minuten',
        fr: 'Thérapie corporelle par le mouvement, par période de 5 minutes',
        it: 'Terapia per il corpo e del movimento, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2019-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1034',
      tarif: '590',
      category: '6.7',
      label: {
        de: 'Craniosacral Therapie, pro 5 Minuten',
        fr: 'Thérapie craniosacrale, par période de 5 minutes',
        it: 'Terapia craniosacrale, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1047',
      tarif: '590',
      category: '6.8',
      label: {
        de: 'Eutonie Gerda Alexander, pro 5 Minuten',
        fr: 'Eutonie Gerda Alexander, par période de 5 minutes',
        it: 'Eutonia Gerda Alexander, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1051',
      tarif: '590',
      category: '6.9',
      label: {
        de: 'Feldenkrais-Therapie, pro 5 Minuten',
        fr: 'Méthode Feldenkrais, par période de 5 minutes',
        it: 'Metodo Feldenkrais, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1055',
      tarif: '590',
      category: '6.1',
      label: {
        de: 'Heileurythmie, pro 5 Minuten',
        fr: 'Eurythmie thérapeutique, par période de 5 minutes',
        it: 'Euritmia terapeutica, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1060',
      tarif: '590',
      category: '6.11',
      label: {
        de: 'Kinesiologie, pro 5 Minuten',
        fr: 'Kinésiologie, par période de 5 minutes',
        it: 'Kinesiologia, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1087',
      tarif: '590',
      category: '6.12',
      label: {
        de: 'Polarity, pro 5 Minuten',
        fr: 'Polarity, par période de 5 minutes',
        it: 'Polarity, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1093',
      tarif: '590',
      category: '6.13',
      label: {
        de: 'Rebalancing, pro 5 Minuten',
        fr: 'Rebalancing par période de 5 minutes',
        it: 'Rebalancing, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1134',
      tarif: '590',
      category: '6.14',
      label: {
        de: 'Reflexzonentherapie, pro 5 Minuten',
        fr: 'Réflexothérapie, par période de 5 minutes',
        it: 'Riflessoterapia, ogni 5 min.'
      },
      description: {
        de:
          'Beinhaltet Körperreflexzonen, Muskelreflexzonen, und Mikrosysteme wie Ohren, Hände und Füsse',
        fr:
          'Comprend le massage des zones réflexes du corps, des muscles et des microsystèmes comme les oreilles, les mains et les pieds.',
        it:
          'Include riflessologia del corpo, riflessologia muscolare e microsistemi come orecchie, mani e piedi'
      },
      validFrom: '2014-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1100',
      tarif: '590',
      category: '6.15',
      label: {
        de: 'Shiatsu, pro 5 Minuten',
        fr: 'Shiatsu, par période de 5 minutes',
        it: 'Shiatsu, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1097',
      tarif: '590',
      category: '6.16',
      label: {
        de: 'Rolfing / Strukturelle Integration, pro 5 Minuten',
        fr: 'Rolfing/intégration structurelle, par période de 5 minutes',
        it: 'Rolfing / Integrazione strutturale, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1054',
      tarif: '590',
      category: '6.17',
      label: {
        de: 'Yoga-Therapie, pro 5 Minuten',
        fr: 'Yoga thérapie, par période de 5 minutes',
        it: 'Yoga terapia, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1029',
      tarif: '590',
      category: '6.18',
      label: {
        de: 'Biodynamische Psychologie / Biodynamik, pro 5 Minuten',
        fr: 'Psychologie biodynamique/Biodynamique, par période de 5 minutes',
        it: 'Psicologia biodinamica / biodinamica, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1050',
      tarif: '590',
      category: '6.19',
      label: {
        de: 'Fasciatherapie, pro 5 Minuten',
        fr: 'Fasciathérapie, par période de 5 minutes',
        it: 'Fasciaterapia, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },

    {
      id: '1257',
      tarif: '590',
      category: '7.0',
      label: {
        de:
          'Koordination der Behandlung mit anderen Gesundheitsfachpersonen, pro 5 Minuten',
        fr:
          "Coordination du traitement avec d'autres professionnels de la santé, par période de 5 minutes",
        it:
          'Coordinamento del trattamento con altri professionisti della salute, ogni 5 min.'
      },
      description: {
        de:
          'Diese Tarifziffer darf nur von Naturheilpraktikern mit eidgenössischem Diplom verwendet werden. Gilt für persönliche oder telefonische Besprechungen von freischaffenden Leistungserbringer mit Gesundheitsfachpersonen (wie Ärzte, Therapeuten, Spitexdienste) in Abwesenheit des Patienten. Gilt nicht für das Aktenstudium oder Besprechungen die in Zusammenhang mit der Erstellung von Berichten stehen.',
        fr:
          "Ce numéros tarifaires ne peut être utilisé que par les naturopathes avec diplôme fédéral. S'applique aux rencontres personnelles ou téléphoniques entre des fournisseurs de services indépendants et des professionnels de santé (médecins, thérapeutes, services Spitex) en l'absence du patient. Ne s'applique pas à l'étude des dossiers ou aux réunions dans le cadre de la préparation des rapports.",
        it:
          'Questa cifre tariffarie può essere utilizzata solo da naturopati con diploma federale. Si applica agli incontri personali o telefonici tra fornitori di servizi freelance e professionisti della salute (come medici, terapisti, servizi Spitex) in assenza del paziente. Non si applica allo studio di fascicoli o riunioni in relazione alla preparazione di relazioni.'
      },
      validFrom: '2020-01-01',
      validTo: '9998-12-31'
    },

    {
      id: '1024',
      tarif: '590',
      category: '7.1',
      label: {
        de: 'Bewegungstherapie, pro 5 Minuten',
        fr:
          'Thérapie par le mouvement (intégrat./cliniq.), par période de 5 minutes',
        it: 'Terapia dei movimenti, integrativa/clinica, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1108',
      tarif: '590',
      category: '7.1',
      label: {
        de: 'Tanztherapie, pro 5 Minuten',
        fr: 'Thérapie par la danse, par période de 5 minutes',
        it: 'Terapia della danza, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },

    {
      id: '1201',
      tarif: '590',
      category: '7.2',
      label: {
        de: 'Dramatherapie, pro 5 Minuten',
        fr: 'Thérapie par le drame, par période de 5 minutes',
        it: 'Drammaterapia, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2016-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1202',
      tarif: '590',
      category: '7.2',
      label: {
        de: 'Therapeutische Sprachgestaltung, pro 5 Minuten',
        fr: 'Art de parole thérapeutique, par période de 5 minutes',
        it: 'Arte della parola terapeutica, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2016-01-01',
      validTo: '9998-12-31'
    },

    {
      id: '1068',
      tarif: '590',
      category: '7.3',
      label: {
        de: 'Maltherapie, pro 5 Minuten',
        fr: 'Thérapie par la peinture, par période de 5 minutes',
        it: 'Terapia della pittura, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1131',
      tarif: '590',
      category: '7.3',
      label: {
        de: 'Gestaltungstherapie, pro 5 Minuten',
        fr: 'Thérapie à médiation plastique, par période de 5 minutes',
        it: 'Terapia di modellagio, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2014-01-01',
      validTo: '9998-12-31'
    },

    {
      id: '1132',
      tarif: '590',
      category: '7.4',
      label: {
        de: 'Intermediale Therapie, pro 5 Minuten',
        fr: 'Thérapie intermédiale, par période de 5 minutes',
        it: 'Terapia intermediale, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2014-01-01',
      validTo: '9998-12-31'
    },

    {
      id: '1072',
      tarif: '590',
      category: '7.5',
      label: {
        de: 'Musiktherapie, pro 5 Minuten',
        fr: 'Musicothérapie, par période de 5 minutes',
        it: 'Musicoterapia, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },

    {
      id: '1039',
      tarif: '590',
      category: '8',
      label: {
        de: 'Elektrotherapie, pro 5 Minuten',
        fr: 'Électrothérapie, par période de 5 minutes',
        it: 'Elettroterapia, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1052',
      tarif: '590',
      category: '8',
      label: {
        de: 'Fussreflexzonen-Therapie pro 5 Minuten',
        fr: 'Massage des zones réflexes du pied, par période de 5 minutes',
        it: 'Riflessologia plantare, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1058',
      tarif: '590',
      category: '8',
      label: {
        de: 'Hydrotherapie,  pro 5 Minuten',
        fr: 'Hydrothérapie, par période de 5 minutes',
        it: 'Idroterapia, ogni 5 min.'
      },
      description: {
        de:
          'Beinhaltet Güsse, Waschungen, Bäder, Kneipp-Wasseranwendungen, Balneologie',
        fr:
          "Comprend jets, lavages, bains, utilisations de l'eau selon Kneipp, balnéologie",
        it:
          "Comprende getti, lavaggi, bagni, trattamenti Kneipp utilizzo dell'acqua, balneoterapia"
      },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1066',
      tarif: '590',
      category: '8',
      label: {
        de: 'Lymphdrainage, manuelle, pro 5 Minuten',
        fr: 'Drainage lymphatique (manuel), par période de 5 minutes',
        it: 'Linfodrenaggio manuale, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1121',
      tarif: '590',
      category: '8',
      label: {
        de: 'Wickel/Umschläge/Fango, pro 5 Minuten',
        fr: 'Cataplasmes/enveloppements/fango, par période de 5 minutes',
        it: 'Cataplasmi/impacchi/fango, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2009-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1213',
      tarif: '590',
      category: '8',
      label: {
        de: 'Massagetechniken, pro 5 Minuten',
        fr: 'Technique de massage, par période de 5 minutes',
        it: 'Tecniche di massaggio, ogni 5 min.'
      },
      description: {
        de:
          'Beinhaltet Bindegewebs-Massage, Colon-Massage, klassische Massage, Triggerpunkt-Massage',
        fr:
          'Comprend le massage du tissu conjonctif, le massage du côlon, le massage classique, le massage des points trigger.',
        it:
          'Comprende massaggio del tessuto connettivo, massaggio del colon, massaggio classico,, massaggio dei punti trigger'
      },
      validFrom: '2019-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1257',
      tarif: '590',
      category: '8',
      label: {
        de:
          'Koordination der Behandlung mit anderen Gesundheitsfachpersonen, pro 5 Minuten',
        fr:
          "Coordination du traitement avec d'autres professionnels de la santé, par période de 5 minutes",
        it:
          'Coordinamento del trattamento con altri professionisti della salute, ogni 5 min.'
      },
      description: {
        de:
          'Diese Tarifziffer darf nur von Naturheilpraktikern mit eidgenössischem Diplom verwendet werden. Gilt für persönliche oder telefonische Besprechungen von freischaffenden Leistungserbringer mit Gesundheitsfachpersonen (wie Ärzte, Therapeuten, Spitexdienste) in Abwesenheit des Patienten. Gilt nicht für das Aktenstudium oder Besprechungen die in Zusammenhang mit der Erstellung von Berichten stehen.',
        fr:
          "Ce numéros tarifaires ne peut être utilisé que par les naturopathes avec diplôme fédéral. S'applique aux rencontres personnelles ou téléphoniques entre des fournisseurs de services indépendants et des professionnels de santé (médecins, thérapeutes, services Spitex) en l'absence du patient. Ne s'applique pas à l'étude des dossiers ou aux réunions dans le cadre de la préparation des rapports.",
        it:
          'Questa cifre tariffarie può essere utilizzata solo da naturopati con diploma federale. Si applica agli incontri personali o telefonici tra fornitori di servizi freelance e professionisti della salute (come medici, terapisti, servizi Spitex) in assenza del paziente. Non si applica allo studio di fascicoli o riunioni in relazione alla preparazione di relazioni.'
      },
      validFrom: '2020-01-01',
      validTo: '9998-12-31'
    },

    {
      id: '1203',
      tarif: '590',
      category: '9',
      label: {
        de: 'Osteopathie, pro 5 Minuten',
        fr: 'Ostéopathie, par période de 5 minutes',
        it: 'Osteopatia, ogni 5 min.'
      },
      description: { de: '', fr: '', it: '' },
      validFrom: '2016-01-01',
      validTo: '9998-12-31'
    },
    {
      id: '1257',
      tarif: '590',
      category: '9',
      label: {
        de:
          'Koordination der Behandlung mit anderen Gesundheitsfachpersonen, pro 5 Minuten',
        fr:
          "Coordination du traitement avec d'autres professionnels de la santé, par période de 5 minutes",
        it:
          'Coordinamento del trattamento con altri professionisti della salute, ogni 5 min.'
      },
      description: {
        de:
          'Diese Tarifziffer darf nur von Naturheilpraktikern mit eidgenössischem Diplom verwendet werden. Gilt für persönliche oder telefonische Besprechungen von freischaffenden Leistungserbringer mit Gesundheitsfachpersonen (wie Ärzte, Therapeuten, Spitexdienste) in Abwesenheit des Patienten. Gilt nicht für das Aktenstudium oder Besprechungen die in Zusammenhang mit der Erstellung von Berichten stehen.',
        fr:
          "Ce numéros tarifaires ne peut être utilisé que par les naturopathes avec diplôme fédéral. S'applique aux rencontres personnelles ou téléphoniques entre des fournisseurs de services indépendants et des professionnels de santé (médecins, thérapeutes, services Spitex) en l'absence du patient. Ne s'applique pas à l'étude des dossiers ou aux réunions dans le cadre de la préparation des rapports.",
        it:
          'Questa cifre tariffarie può essere utilizzata solo da naturopati con diploma federale. Si applica agli incontri personali o telefonici tra fornitori di servizi freelance e professionisti della salute (come medici, terapisti, servizi Spitex) in assenza del paziente. Non si applica allo studio di fascicoli o riunioni in relazione alla preparazione di relazioni.'
      },
      validFrom: '2020-01-01',
      validTo: '9998-12-31'
    }
  ]
};
